import React from 'react';
import { Input, Button, PaperClip, Select, Textarea } from 'components';
import { QuoteService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { WhiteImage } from 'assets/img';
import { connect } from 'react-redux';

interface Props extends RootState {
	onClose?: any;
	item?: any;
}

class ModalQuote extends React.Component<Props> {

	state = {
		form: {
			file: ''
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	submit = async () => {
		if (!this.state.form.file) {
			Globals.showError("Debe cargar el archivo para enviar la cotización");
			return;
		}
		await QuoteService.clinic.send({
			...this.state.form,
			user_id: this.props.user?.id,
			hasFile: true,
			// @ts-ignore,
			file: this.state.form.file?.value || '',
			quote_id: this.props.item?.id
		});
		Globals.showSuccess("Se ha enviado la cotización correctamente");
		this.props.onClose();
	}
	
	render() {
		return (
			<div id="modal-clinic-send-quote">
				<h3>Cotización de Cirugía</h3>
				<p><strong>Paso 1-</strong> Seleccione el archivo PDF</p>
				<PaperClip
					formats={['pdf']}
					value={ this.state.form.file }
					successText="Archivo cargado correctamente"
					pendingText="Busca archivo"
					onChange={ (e: any) => {
						this.setState({
							form: {
								...this.state.form,
								file: e.target
							}
						})
					} }>
				</PaperClip>
				<p><strong>Paso 2-</strong> Confirme que el archivo se cargue correctamente</p>
				<p><strong>Paso 3-</strong> Seleccione enviar</p>
				<div className="row row-buttons">
					<div className="col-md-6 text-center">
						<Button type="button" className="btn-close" onClick={ () => this.props.onClose() }>
							Cerrar
						</Button>
					</div>
					<div className="col-md-6 text-center">
						<Button type="button" className="btn-submit" onClick={ () => this.submit() }>
							Enviar
						</Button>
					</div>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(ModalQuote);